import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import restEnLang from './locales/en/rest.en.json'
import restIdLang from './locales/id/rest.id.json'

/**
 * Login page and its components localization
 */
import loginEnLang from './locales/en/login.en.json'
import loginIdLang from './locales/id/login.id.json'

/**
 * Team page and its components localization
 */
import teamEnLang from './locales/en/team.en.json'
import teamIdLang from './locales/id/team.id.json'

/**
 * Member page and its components localization
 */
import memberEnLang from './locales/en/member.en.json'
import memberIdLang from './locales/id/member.id.json'

/**
 * Invitation page and its components localization
 */
import invitationEnLang from './locales/en/invitation.en.json'
import invitationIdLang from './locales/id/invitation.id.json'

/**
 * Multiple Reschedule Component and its components localization
 */
import multipleRescheduleEnLang from './locales/en/multipleReschedule.en.json'
import multipleRescheduleIdLang from './locales/id/multipleReschedule.id.json'

/**
 * Master Tugas Page and its components localization
 */
import masterTugasEnLang from './locales/en/masterTugas.en.json'
import masterTugasIdLang from './locales/id/masterTugas.id.json'
/**
 * Master Outlet Page and its components localization
 */
import masterOutletEnLang from './locales/en/masterOutlet.en.json'
import masterOutletIdLang from './locales/id/masterOutlet.id.json'

/**
 * Master Product page and its components localization
 */
import masterProductEnLang from './locales/en/masterProduct.en.json'
import masterProductIdLang from './locales/id/masterProduct.id.json'

/**
 * Settlement page and its components localization
 */
import settlementEnLang from './locales/en/settlement.en.json'
import settlementIdLang from './locales/id/settlement.id.json'

/**
 * Commission page and its components localization
 */
import commissionEnLang from './locales/en/commission.en.json'
import commissionIdLang from './locales/id/commission.id.json'

/**
 * Transactions page and its components localization
 */
import transactionEnLang from './locales/en/transaction.en.json'
import transactionIdLang from './locales/id/transaction.id.json'

/**
 * Bulletin page and its components localization
 */
import bulletinEnLang from './locales/en/bulletin.en.json'
import bulletinIdLang from './locales/id/bulletin.id.json'

/**
 * Bulletin page and its components localization
 */
import leadEnLang from './locales/en/lead.en.json'
import leadIdLang from './locales/id/lead.id.json'

/**
 * Task Calendar View page and its components localization
 */
import taskCalendarViewEnLang from './locales/en/taskCalendarView.en.json'
import taskCalendarViewIdLang from './locales/id/taskCalendarView.id.json'

/**
 * Master Ingredient page and its components localization
 */
import masterIngredientEnLang from './locales/en/masterIngredient.en.json'
import masterIngredientIdLang from './locales/id/masterIngredient.id.json'

/**
 * Master Ingredient page and its components localization
 */
import masterRecipeEnLang from './locales/en/masterRecipe.en.json'
import masterRecipeIdLang from './locales/id/masterRecipe.id.json'

/**
 * Master Outlet page and its components localization
 */
import masterStoreEnLang from './locales/en/masterStore.en.json'
import masterStoreIdLang from './locales/id/masterStore.id.json'

/**
 * Cost Perdin page and its components locazation
 */
import costPerdinEnLang from './locales/en/costPerdin.en.json'
import costPerdinIdLang from './locales/id/costPerdin.id.json'

/**
 * Access Menu page and its components locazation
 */
import accessMenuEnLang from './locales/en/accessMenu.en.json'
import accessMenuIdLang from './locales/id/accessMenu.id.json'

/**
 * Personal Dashboard Maximus page and its components locazation
 */
import personalDashboardMaximusEnLang from './locales/en/personalDashboardMaximus.en.json'
import personalDashboardMaximusIdLang from './locales/id/personalDashboardMaximus.id.json'

/**
 * Plan Visit page and its components locazation
 */
import planVisitEnLang from './locales/en/planVisit.en.json'
import planVisitIdLang from './locales/id/planVisit.id.json'

/**
 * Sales Order page and its components locazation
 */
import salesOrderEnLang from './locales/en/salesOrder.en.json'
import salesOrderIdLang from './locales/id/salesOrder.id.json'

/**
 * Sales Order page and its components locazation
 */
import posEnLang from './locales/en/pos.en.json'
import posIdLang from './locales/id/pos.id.json'

/**
 * Personal Dashboard Hisense page and its components locazation
 */
import personalDashboardHisenseEnLang from './locales/en/personalDashboardHisense.en.json'
import personalDashboardHisenseEnLangIdLang from './locales/id/personalDashboardHisense.id.json'

/**
 * Personal Dashboard Jarivis Pest Control page and its components locazation
 */
import personalDashboardEnLang from './locales/en/personalDashboard.en.json'
import personalDashboardEnLangIdLang from './locales/id/personalDashboard.id.json'

/**
 * SidebarV2 components locazation
 */
import sidebarV2EnLang from './locales/en/sidebar-v2.en.json'
import sidebarV2IdLang from './locales/id/sidebar-v2.id.json'

/**
 * App Builder page and its components locazation
 */
import appBuilderEnLang from './locales/en/app-builder.en.json'
import appBuilderIdLang from './locales/id/app-builder.id.json'

/**
 * Chakra react select v4 components locazation
 */
import chakraReactSelectV4EnLang from './locales/en/chakra-react-select-v4.en.json'
import chakraReactSelectV4IdLang from './locales/id/chakra-react-select-v4.id.json'

/**
 * Beta release banner component localization
 */
import betaNotifEnLang from './locales/en/betaNotif.en.json'
import betaNotifIdLang from './locales/id/betaNotif.id.json'

const resources = {
    en: {
        translation: {
            ...loginEnLang,
            ...teamEnLang,
            ...memberEnLang,
            ...invitationEnLang,
            ...multipleRescheduleEnLang,
            ...masterTugasEnLang,
            ...masterOutletEnLang,
            ...settlementEnLang,
            ...commissionEnLang,
            ...transactionEnLang,
            ...masterProductEnLang,
            ...bulletinEnLang,
            ...leadEnLang,
            ...restEnLang,
            ...taskCalendarViewEnLang,
            ...masterIngredientEnLang,
            ...masterRecipeEnLang,
            ...masterStoreEnLang,
            ...costPerdinEnLang,
            ...accessMenuEnLang,
            ...personalDashboardMaximusEnLang,
            ...planVisitEnLang,
            ...salesOrderEnLang,
            ...posEnLang,
            ...personalDashboardHisenseEnLang,
            ...personalDashboardEnLang,
            ...sidebarV2EnLang,
            ...appBuilderEnLang,
            ...chakraReactSelectV4EnLang,
            ...betaNotifEnLang,
        },
    },
    id: {
        translation: {
            ...loginIdLang,
            ...teamIdLang,
            ...memberIdLang,
            ...invitationIdLang,
            ...multipleRescheduleIdLang,
            ...masterTugasIdLang,
            ...masterOutletIdLang,
            ...settlementIdLang,
            ...commissionIdLang,
            ...transactionIdLang,
            ...masterProductIdLang,
            ...bulletinIdLang,
            ...leadIdLang,
            ...restIdLang,
            ...taskCalendarViewIdLang,
            ...masterIngredientIdLang,
            ...masterRecipeIdLang,
            ...masterStoreIdLang,
            ...costPerdinIdLang,
            ...accessMenuIdLang,
            ...personalDashboardMaximusIdLang,
            ...planVisitIdLang,
            ...salesOrderIdLang,
            ...posIdLang,
            ...personalDashboardHisenseEnLangIdLang,
            ...personalDashboardEnLangIdLang,
            ...sidebarV2IdLang,
            ...appBuilderIdLang,
            ...chakraReactSelectV4IdLang,
            ...betaNotifIdLang,
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('i18nextLng') || 'id', 
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
